export interface TechGroup {
  label: string;
  /** One line on what the group covers (shown on /services). */
  summary: string;
  items: string[];
}

export const TECH_STACK: TechGroup[] = [
  { label: "Backend", summary: "Services, APIs and business logic", items: [".NET / C#", "Node.js", "Python", "Java"] },
  { label: "Frontend", summary: "Web interfaces and single-page apps", items: ["Angular", "React", "Next.js"] },
  { label: "Cloud & Data", summary: "Hosting, infrastructure and databases", items: ["Azure", "AWS", "SQL Server", "PostgreSQL"] },
  { label: "Engineering", summary: "Delivery pipelines and architecture", items: ["Docker", "CI/CD", "Microservices", "API Development"] },
];

// Short strip shown under the hero.
export const TECH_STRIP = [
  ".NET",
  "Angular",
  "React",
  "Python",
  "Azure",
  "Cloud",
  "AI",
];
